module.exports = __webpack_public_path__ + "static/media/google-play-social-media-svgrepo-com (1).02f19110.svg";